import React from "react";
import { useDispatch } from "react-redux";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Fab from "@mui/material/Fab";
import Chip from "@mui/material/Chip";
import { Link } from "react-router-dom";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";

const ReceiptTableRow = (props) => {
	const dispatch = useDispatch();

	const clickHandler = () => {
		dispatch({
			type: "assign",
			payload: {
				prevRoute: "/clinic/receipts/",
				index: 0,
			},
		});
	};

	return (
		<TableRow hover>
			<TableCell align="justify">
				<Link
					to={`/clinic/receipts/${props.receiptId}`}
					style={{ color: "inherit", textDecoration: "inherit" }}
				>
					<Fab color="secondary" size="small" onClick={clickHandler}>
						<DatasetLinkedIcon />
					</Fab>
				</Link>
			</TableCell>
			<TableCell align="justify">{props.receiptCode}</TableCell>
			<TableCell align="justify">{props.submissionDate}</TableCell>
			<TableCell align="justify">{props.laboratory}</TableCell>
			<TableCell align="justify">{props.name}</TableCell>
			<TableCell align="justify">{props.orderCount}</TableCell>
			<TableCell align="justify">{props.totalPrice}</TableCell>
			<TableCell align="justify">
				<Chip
					label={props.isPaid ? "پرداخت شده" : "پرداخت نشده"}
					color={props.isPaid ? "success" : "error"}
				/>
			</TableCell>
		</TableRow>
	);
};

export default ReceiptTableRow;
